export type SiteModuleId = 'tools' | 'nsdq' | 'kids'

export interface SiteModule {
  id: SiteModuleId
  name: string
  description: string
  href: string
  icon: 'Wrench' | 'LineChart' | 'Users'
}

export const siteModules: SiteModule[] = [
  {
    id: 'tools',
    name: '在线工具',
    description: '图片、PDF、文本和开发工具',
    href: '/tools',
    icon: 'Wrench'
  },
  {
    id: 'nsdq',
    name: '纳指看板',
    description: '查看纳指趋势和估值数据',
    href: '/nsdq/',
    icon: 'LineChart'
  },
  {
    id: 'kids',
    name: '亲子资源库',
    description: '收集家庭可用的亲子资源',
    href: '/kids/',
    icon: 'Users'
  }
]
